import { AccountingDocumentStatus } from '@/models/accounting-document.model';

export const ClosedAccountingDocumentStatuses = [AccountingDocumentStatus.Settled] as AccountingDocumentStatus[];
